const isEqualObjects = (
  firstObj: {[key: string]: any},
  secondObj: {[key: string]: any},
) =>
  Object.keys(firstObj).every(key => firstObj[key] === secondObj[key]) &&
  Object.keys(secondObj).every(key => firstObj[key] === secondObj[key]);

export default isEqualObjects;
